export default "__VITE_ASSET__ByS$NNRY__"